import { ResponsivePie } from "@nivo/pie";
import { tokens } from "../../../../theme";
import { Box, useTheme } from "@mui/material";

export const ElectricityUsageBalanceChart = ({ dataValues = [], meta = []}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const unit = dataValues[0]["unit"]
  
  return (
      <Box sx={{ width: { lg: '300px', md: '80vh', xs:'270px' }, height: { xl: '200px', lg: '200px', sm:'200px', xs:'200px'} }}>
        <ResponsivePie
          data={dataValues}
          tooltip={point => {
            return (
              <div style={{backgroundColor: 'white', color: 'black', padding: '5px', borderRadius: '10px'}}>
                <div>{`${point.datum.value}${unit} ${point.datum.label}`}</div>
              </div>
            )
          }}
          theme={{
            axis: {
              domain: {
                line: {
                  stroke: colors.grey[100],
                },
              },
              legend: {
                text: {
                  fill: colors.grey[100],
                },
              },
              ticks: {
                line: {
                  stroke: colors.grey[100],
                  strokeWidth: 1,
                },
                text: {
                  fill: colors.grey[100],
                },
              },
            },
            legends: {
              text: {
                fill: colors.grey[100],
              },
            },
          }}
          enableArcLinkLabels={false}
          colors={row => row.data.color}
          margin={{ top: 20, right: 0, bottom: 60, left: 0 }}
          innerRadius={0}
          padAngle={0}
          cornerRadius={0}
          activeOuterRadiusOffset={8}
          borderColor={{
            from: "color",
            modifiers: [["darker", 0.2]],
          }}
          arcLinkLabelsSkipAngle={10}
          arcLinkLabelsTextColor={colors.grey[100]}
          arcLinkLabelsThickness={2}
          arcLinkLabelsColor={{ from: "color" }}
          valueFormat={(value) => value + unit}
          enableArcLabels={true}
          arcLabelsRadiusOffset={1.5}
          arcLabelsSkipAngle={7}
          arcLabelsTextColor={{
            from: "color",
            modifiers: [["darker", 2]],
          }}
          legends={[
            {
              anchor: "bottom",
              direction: "row",
              justify: false,
              translateX: 0,
              translateY: 50,
              itemsSpacing: 0,
              itemWidth: 120,
              itemHeight: 0,
              itemTextColor: "#999",
              itemDirection: "left-to-right",
              itemOpacity: 1,
              symbolSize: 18,
              symbolShape: "circle",
              effects: [
                {
                  on: "hover",
                  style: {
                    itemTextColor: "#000",
                  },
                },
              ],
            },
          ]}
        />
      </Box>  
      );
};